var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-view-stage-cerpanie"
  }, [_c('document-cloud-handler', {
    attrs: {
      "cloud-meta": _vm.getCloudMeta(),
      "rules": ['single'],
      "class-cst": 'cloud-button add-obhliadka white--text no-decoration',
      "icon-button": ""
    }
  }), _c('contract-sign'), _c('application-document-finish')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }